<button mat-stroked-button type="button" class="location-selector-trigger" [matMenuTriggerFor]="locationMenu" [disabled]="locating()">
  <mat-icon>{{ locating() ? 'hourglass_top' : 'place' }}</mat-icon>
  {{ locating() ? 'Localizando…' : selected_label }}
  <mat-icon iconPositionEnd>expand_more</mat-icon>
</button>

<mat-menu #locationMenu="matMenu" class="location-selector-menu">
  @for (option of options(); track option.id) {
    <button mat-menu-item type="button" (click)="onSelectionChange(option)">
      <mat-icon>place</mat-icon>
      <span class="location-selector-option-label">{{ option.name }}</span>
      <span class="location-selector-option-chips">
        @if (option.matched_by_ip) {
          <span class="location-selector-match-chip location-selector-match-chip-ip">IP</span>
        }
        @if (option.matched_by_coordinates) {
          <span class="location-selector-match-chip location-selector-match-chip-near">Cercana</span>
        }
      </span>
    </button>
  }

  @if (options().length === 0 && !locating()) {
    <button mat-menu-item type="button" disabled>
      <span>No hay ubicaciones sugeridas</span>
    </button>
  }

  @if (options().length > 0 && can_create_location) {
    <mat-divider></mat-divider>
  }

  @if (can_create_location) {
    <button mat-menu-item type="button" (click)="openCreateDialog()">
      <mat-icon>add_location_alt</mat-icon>
      <span>Crear ubicación</span>
    </button>
  }
</mat-menu>
